import { React, useState } from "react";
import {
  Input,
  Row,
  Typography,
  Form,
  Col,
  Select,
  DatePicker,
  Spin,
  InputNumber,
  Divider,
  Space,
  Button,
  Checkbox,
  Tooltip,
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
const { Text, Title } = Typography;

const SettingsForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    isWithholdTaxValue,
    preClosure,
    maturityInstructionOptions,
    savingsAccountOptions,
  } = props;

  const isWithHoldTax = Form.useWatch("withHoldTax", form);
  const maturityInstruction = Form.useWatch("maturityInstructionId", form);

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={initialValues}
      style={{ margin: 30 }}
    >
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.depositInformation}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.minimumDepositTerm}</Text>}
            name={"minDepositTermDisplay"}
          >
            <Input disabled className="of-bold-disable-input" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.thereAferTerms}</Text>}
            name={"inMultiplesOfDepositTerm"}
          >
            <Input disabled className="of-bold-disable-input" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.maximumDepositTerm}</Text>}
            name={"maxDepositTermDisplay"}
          >
            <Input disabled className="of-bold-disable-input" />
          </Form.Item>
        </Col>

        {preClosure && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<Text>{labelConfig.preMatureClosure}</Text>}
              name={"preMatureClosure"}
            >
              <Input disabled className="of-bold-disable-input" />
            </Form.Item>
          </Col>
        )}

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip
                title={labelConfig.transferInterestToLinkedSavingsAccount}
              >
                {BOM.SubstringFormat(
                  labelConfig.transferInterestToLinkedSavingsAccount,
                  20
                )}
              </Tooltip>
            }
            name={"transferInterestToSavings"}
          >
            <Select
              placeholder="Select Option"
              options={staticConfig.yesOrNo}
              showSearch
              allowClear
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.linkAccount}</Text>}
            name={"linkAccountId"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder="Select one"
              options={savingsAccountOptions}
              showSearch
              allowClear
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.maturityInstruction}</Text>}
            name={"maturityInstructionId"}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder="Select one"
              options={maturityInstructionOptions}
              showSearch
              allowClear
            />
          </Form.Item>
        </Col>
        {maturityInstruction === 200 && (
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Tooltip title={labelConfig.transferToAccount}>
                  {BOM.SubstringFormat(labelConfig.transferToAccount, 20)}
                </Tooltip>
              }
              name={"transferToSavingsId"}
            >
              <Select
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input?.toLowerCase()
                  )
                }
                placeholder="Select one"
                options={savingsAccountOptions}
                showSearch
                allowClear
              />
            </Form.Item>
          </Col>
        )}
      </Row>
      {isWithholdTaxValue && (
        <>
          <Divider orientation="left" orientationMargin="0">
            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
              {labelConfig.taxInfo}
            </Title>
          </Divider>
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<Text>{labelConfig.isWithholdTax}</Text>}
                name={"withHoldTax"}
              >
                <Select
                  filterOption={(input, option) =>
                    (option?.label?.toLowerCase() ?? "").includes(
                      input?.toLowerCase()
                    )
                  }
                  placeholder="Select one"
                  options={staticConfig.yesOrNoData}
                  showSearch
                  allowClear
                />
              </Form.Item>
            </Col>
            {isWithHoldTax && (
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<Text>{labelConfig.taxGroup}</Text>}
                  name={"taxGroup"}
                >
                  <Input disabled className="of-bold-disable-input" />
                </Form.Item>
              </Col>
            )}
          </Row>
        </>
      )}
    </Form>
  );
};

export default SettingsForm;
